// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    RESTLinkHAL,
} from './';

/**
 * @export
 * @interface RESTM365BackupStoragePolicyGroup
 */
export interface RESTM365BackupStoragePolicyGroup {
    /**
     * Organization group ID.
     * @type {string}
     * @memberof RESTM365BackupStoragePolicyGroup
     */
    id?: string;
    /**
     * Version number that Veeam Backup for Microsoft 365 assigns if the organization group was modified.
     * @type {number}
     * @memberof RESTM365BackupStoragePolicyGroup
     */
    eTag?: number | null;
    /**
     * Display name of the organization group.
     * @type {string}
     * @memberof RESTM365BackupStoragePolicyGroup
     */
    displayName?: string;
    /**
     * Name of the organization group.
     * @type {string}
     * @memberof RESTM365BackupStoragePolicyGroup
     */
    name?: string | null;
    /**
     * User who manages the organization group.
     * @type {string}
     * @memberof RESTM365BackupStoragePolicyGroup
     */
    managedBy?: string | null;
    /**
     * Site of the organization group.
     * @type {string}
     * @memberof RESTM365BackupStoragePolicyGroup
     */
    site?: string | null;
    /**
     * Type of the organization group.
     * @type {string}
     * @memberof RESTM365BackupStoragePolicyGroup
     */
    type?: RESTM365BackupStoragePolicyGroupTypeEnum;
    /**
     * Microsoft 365 organization deployment type.
     * @type {string}
     * @memberof RESTM365BackupStoragePolicyGroup
     */
    locationType?: RESTM365BackupStoragePolicyGroupLocationTypeEnum;
    /**
     * ID of the organization group assigned by Microsoft.
     * @type {string}
     * @memberof RESTM365BackupStoragePolicyGroup
     */
    msid?: string | null;
    /**
     * Related resources.
     * @type {{ [key: string]: RESTLinkHAL; }}
     * @memberof RESTM365BackupStoragePolicyGroup
     */
    _links?: { [key: string]: RESTLinkHAL; };
}

/**
 * @export
 * @enum {string}
 */
export enum RESTM365BackupStoragePolicyGroupTypeEnum {
    Office365 = 'Office365',
    Security = 'Security',
    Distribution = 'Distribution',
    DynamicDistribution = 'DynamicDistribution'
}
/**
 * @export
 * @enum {string}
 */
export enum RESTM365BackupStoragePolicyGroupLocationTypeEnum {
    OnPremises = 'OnPremises',
    Cloud = 'Cloud',
    Hybrid = 'Hybrid'
}

